/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedExplanationsRouteRouteImport } from './routes/_authenticated/explanations/route'
import { Route as AuthenticatedscenicScenicAreaCategoriesRouteImport } from './routes/_authenticated/(scenic)/scenic-area-categories'
import { Route as AuthenticatedregionCountriesRouteImport } from './routes/_authenticated/(region)/countries'
import { Route as AuthenticatedregionContinentsRouteImport } from './routes/_authenticated/(region)/continents'
import { Route as AuthenticatedregionCitiesRouteImport } from './routes/_authenticated/(region)/cities'
import { Route as AuthenticatedscenicScenicSpotsIndexRouteImport } from './routes/_authenticated/(scenic)/scenic-spots/index'
import { Route as AuthenticatedscenicScenicAreasIndexRouteImport } from './routes/_authenticated/(scenic)/scenic-areas/index'
import { Route as AuthenticatedExplanationsRegionTypeIdRouteImport } from './routes/_authenticated/explanations/$regionType.$id'
import { Route as AuthenticatedscenicScenicSpotsAddRouteImport } from './routes/_authenticated/(scenic)/scenic-spots/add'
import { Route as AuthenticatedscenicScenicAreasAddRouteImport } from './routes/_authenticated/(scenic)/scenic-areas/add'
import { Route as AuthenticatedscenicScenicSpotsIdEditRouteImport } from './routes/_authenticated/(scenic)/scenic-spots/$id.edit'
import { Route as AuthenticatedscenicScenicAreasIdEditRouteImport } from './routes/_authenticated/(scenic)/scenic-areas/$id.edit'

const errors503LazyRouteImport = createFileRoute('/(errors)/503')()
const errors500LazyRouteImport = createFileRoute('/(errors)/500')()
const errors404LazyRouteImport = createFileRoute('/(errors)/404')()
const errors403LazyRouteImport = createFileRoute('/(errors)/403')()
const errors401LazyRouteImport = createFileRoute('/(errors)/401')()

const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const errors503LazyRoute = errors503LazyRouteImport
  .update({
    id: '/(errors)/503',
    path: '/503',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/503.lazy').then((d) => d.Route))
const errors500LazyRoute = errors500LazyRouteImport
  .update({
    id: '/(errors)/500',
    path: '/500',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/500.lazy').then((d) => d.Route))
const errors404LazyRoute = errors404LazyRouteImport
  .update({
    id: '/(errors)/404',
    path: '/404',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/404.lazy').then((d) => d.Route))
const errors403LazyRoute = errors403LazyRouteImport
  .update({
    id: '/(errors)/403',
    path: '/403',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/403.lazy').then((d) => d.Route))
const errors401LazyRoute = errors401LazyRouteImport
  .update({
    id: '/(errors)/401',
    path: '/401',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/401.lazy').then((d) => d.Route))
const AuthenticatedExplanationsRouteRoute =
  AuthenticatedExplanationsRouteRouteImport.update({
    id: '/explanations',
    path: '/explanations',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedscenicScenicAreaCategoriesRoute =
  AuthenticatedscenicScenicAreaCategoriesRouteImport.update({
    id: '/(scenic)/scenic-area-categories',
    path: '/scenic-area-categories',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedregionCountriesRoute =
  AuthenticatedregionCountriesRouteImport.update({
    id: '/(region)/countries',
    path: '/countries',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedregionContinentsRoute =
  AuthenticatedregionContinentsRouteImport.update({
    id: '/(region)/continents',
    path: '/continents',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedregionCitiesRoute =
  AuthenticatedregionCitiesRouteImport.update({
    id: '/(region)/cities',
    path: '/cities',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedscenicScenicSpotsIndexRoute =
  AuthenticatedscenicScenicSpotsIndexRouteImport.update({
    id: '/(scenic)/scenic-spots/',
    path: '/scenic-spots/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedscenicScenicAreasIndexRoute =
  AuthenticatedscenicScenicAreasIndexRouteImport.update({
    id: '/(scenic)/scenic-areas/',
    path: '/scenic-areas/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedExplanationsRegionTypeIdRoute =
  AuthenticatedExplanationsRegionTypeIdRouteImport.update({
    id: '/$regionType/$id',
    path: '/$regionType/$id',
    getParentRoute: () => AuthenticatedExplanationsRouteRoute,
  } as any)
const AuthenticatedscenicScenicSpotsAddRoute =
  AuthenticatedscenicScenicSpotsAddRouteImport.update({
    id: '/(scenic)/scenic-spots/add',
    path: '/scenic-spots/add',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedscenicScenicAreasAddRoute =
  AuthenticatedscenicScenicAreasAddRouteImport.update({
    id: '/(scenic)/scenic-areas/add',
    path: '/scenic-areas/add',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedscenicScenicSpotsIdEditRoute =
  AuthenticatedscenicScenicSpotsIdEditRouteImport.update({
    id: '/(scenic)/scenic-spots/$id/edit',
    path: '/scenic-spots/$id/edit',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedscenicScenicAreasIdEditRoute =
  AuthenticatedscenicScenicAreasIdEditRouteImport.update({
    id: '/(scenic)/scenic-areas/$id/edit',
    path: '/scenic-areas/$id/edit',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/explanations': typeof AuthenticatedExplanationsRouteRouteWithChildren
  '/401': typeof errors401LazyRoute
  '/403': typeof errors403LazyRoute
  '/404': typeof errors404LazyRoute
  '/500': typeof errors500LazyRoute
  '/503': typeof errors503LazyRoute
  '/': typeof AuthenticatedIndexRoute
  '/cities': typeof AuthenticatedregionCitiesRoute
  '/continents': typeof AuthenticatedregionContinentsRoute
  '/countries': typeof AuthenticatedregionCountriesRoute
  '/scenic-area-categories': typeof AuthenticatedscenicScenicAreaCategoriesRoute
  '/scenic-areas/add': typeof AuthenticatedscenicScenicAreasAddRoute
  '/scenic-spots/add': typeof AuthenticatedscenicScenicSpotsAddRoute
  '/explanations/$regionType/$id': typeof AuthenticatedExplanationsRegionTypeIdRoute
  '/scenic-areas': typeof AuthenticatedscenicScenicAreasIndexRoute
  '/scenic-spots': typeof AuthenticatedscenicScenicSpotsIndexRoute
  '/scenic-areas/$id/edit': typeof AuthenticatedscenicScenicAreasIdEditRoute
  '/scenic-spots/$id/edit': typeof AuthenticatedscenicScenicSpotsIdEditRoute
}
export interface FileRoutesByTo {
  '/explanations': typeof AuthenticatedExplanationsRouteRouteWithChildren
  '/401': typeof errors401LazyRoute
  '/403': typeof errors403LazyRoute
  '/404': typeof errors404LazyRoute
  '/500': typeof errors500LazyRoute
  '/503': typeof errors503LazyRoute
  '/': typeof AuthenticatedIndexRoute
  '/cities': typeof AuthenticatedregionCitiesRoute
  '/continents': typeof AuthenticatedregionContinentsRoute
  '/countries': typeof AuthenticatedregionCountriesRoute
  '/scenic-area-categories': typeof AuthenticatedscenicScenicAreaCategoriesRoute
  '/scenic-areas/add': typeof AuthenticatedscenicScenicAreasAddRoute
  '/scenic-spots/add': typeof AuthenticatedscenicScenicSpotsAddRoute
  '/explanations/$regionType/$id': typeof AuthenticatedExplanationsRegionTypeIdRoute
  '/scenic-areas': typeof AuthenticatedscenicScenicAreasIndexRoute
  '/scenic-spots': typeof AuthenticatedscenicScenicSpotsIndexRoute
  '/scenic-areas/$id/edit': typeof AuthenticatedscenicScenicAreasIdEditRoute
  '/scenic-spots/$id/edit': typeof AuthenticatedscenicScenicSpotsIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/_authenticated/explanations': typeof AuthenticatedExplanationsRouteRouteWithChildren
  '/(errors)/401': typeof errors401LazyRoute
  '/(errors)/403': typeof errors403LazyRoute
  '/(errors)/404': typeof errors404LazyRoute
  '/(errors)/500': typeof errors500LazyRoute
  '/(errors)/503': typeof errors503LazyRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/(region)/cities': typeof AuthenticatedregionCitiesRoute
  '/_authenticated/(region)/continents': typeof AuthenticatedregionContinentsRoute
  '/_authenticated/(region)/countries': typeof AuthenticatedregionCountriesRoute
  '/_authenticated/(scenic)/scenic-area-categories': typeof AuthenticatedscenicScenicAreaCategoriesRoute
  '/_authenticated/(scenic)/scenic-areas/add': typeof AuthenticatedscenicScenicAreasAddRoute
  '/_authenticated/(scenic)/scenic-spots/add': typeof AuthenticatedscenicScenicSpotsAddRoute
  '/_authenticated/explanations/$regionType/$id': typeof AuthenticatedExplanationsRegionTypeIdRoute
  '/_authenticated/(scenic)/scenic-areas/': typeof AuthenticatedscenicScenicAreasIndexRoute
  '/_authenticated/(scenic)/scenic-spots/': typeof AuthenticatedscenicScenicSpotsIndexRoute
  '/_authenticated/(scenic)/scenic-areas/$id/edit': typeof AuthenticatedscenicScenicAreasIdEditRoute
  '/_authenticated/(scenic)/scenic-spots/$id/edit': typeof AuthenticatedscenicScenicSpotsIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/explanations'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/'
    | '/cities'
    | '/continents'
    | '/countries'
    | '/scenic-area-categories'
    | '/scenic-areas/add'
    | '/scenic-spots/add'
    | '/explanations/$regionType/$id'
    | '/scenic-areas'
    | '/scenic-spots'
    | '/scenic-areas/$id/edit'
    | '/scenic-spots/$id/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/explanations'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/'
    | '/cities'
    | '/continents'
    | '/countries'
    | '/scenic-area-categories'
    | '/scenic-areas/add'
    | '/scenic-spots/add'
    | '/explanations/$regionType/$id'
    | '/scenic-areas'
    | '/scenic-spots'
    | '/scenic-areas/$id/edit'
    | '/scenic-spots/$id/edit'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_authenticated/explanations'
    | '/(errors)/401'
    | '/(errors)/403'
    | '/(errors)/404'
    | '/(errors)/500'
    | '/(errors)/503'
    | '/_authenticated/'
    | '/_authenticated/(region)/cities'
    | '/_authenticated/(region)/continents'
    | '/_authenticated/(region)/countries'
    | '/_authenticated/(scenic)/scenic-area-categories'
    | '/_authenticated/(scenic)/scenic-areas/add'
    | '/_authenticated/(scenic)/scenic-spots/add'
    | '/_authenticated/explanations/$regionType/$id'
    | '/_authenticated/(scenic)/scenic-areas/'
    | '/_authenticated/(scenic)/scenic-spots/'
    | '/_authenticated/(scenic)/scenic-areas/$id/edit'
    | '/_authenticated/(scenic)/scenic-spots/$id/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  errors401LazyRoute: typeof errors401LazyRoute
  errors403LazyRoute: typeof errors403LazyRoute
  errors404LazyRoute: typeof errors404LazyRoute
  errors500LazyRoute: typeof errors500LazyRoute
  errors503LazyRoute: typeof errors503LazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/(errors)/503': {
      id: '/(errors)/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof errors503LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/500': {
      id: '/(errors)/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof errors500LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/404': {
      id: '/(errors)/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof errors404LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/403': {
      id: '/(errors)/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof errors403LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/401': {
      id: '/(errors)/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof errors401LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/explanations': {
      id: '/_authenticated/explanations'
      path: '/explanations'
      fullPath: '/explanations'
      preLoaderRoute: typeof AuthenticatedExplanationsRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/(scenic)/scenic-area-categories': {
      id: '/_authenticated/(scenic)/scenic-area-categories'
      path: '/scenic-area-categories'
      fullPath: '/scenic-area-categories'
      preLoaderRoute: typeof AuthenticatedscenicScenicAreaCategoriesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/(region)/countries': {
      id: '/_authenticated/(region)/countries'
      path: '/countries'
      fullPath: '/countries'
      preLoaderRoute: typeof AuthenticatedregionCountriesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/(region)/continents': {
      id: '/_authenticated/(region)/continents'
      path: '/continents'
      fullPath: '/continents'
      preLoaderRoute: typeof AuthenticatedregionContinentsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/(region)/cities': {
      id: '/_authenticated/(region)/cities'
      path: '/cities'
      fullPath: '/cities'
      preLoaderRoute: typeof AuthenticatedregionCitiesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/(scenic)/scenic-spots/': {
      id: '/_authenticated/(scenic)/scenic-spots/'
      path: '/scenic-spots'
      fullPath: '/scenic-spots'
      preLoaderRoute: typeof AuthenticatedscenicScenicSpotsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/(scenic)/scenic-areas/': {
      id: '/_authenticated/(scenic)/scenic-areas/'
      path: '/scenic-areas'
      fullPath: '/scenic-areas'
      preLoaderRoute: typeof AuthenticatedscenicScenicAreasIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/explanations/$regionType/$id': {
      id: '/_authenticated/explanations/$regionType/$id'
      path: '/$regionType/$id'
      fullPath: '/explanations/$regionType/$id'
      preLoaderRoute: typeof AuthenticatedExplanationsRegionTypeIdRouteImport
      parentRoute: typeof AuthenticatedExplanationsRouteRoute
    }
    '/_authenticated/(scenic)/scenic-spots/add': {
      id: '/_authenticated/(scenic)/scenic-spots/add'
      path: '/scenic-spots/add'
      fullPath: '/scenic-spots/add'
      preLoaderRoute: typeof AuthenticatedscenicScenicSpotsAddRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/(scenic)/scenic-areas/add': {
      id: '/_authenticated/(scenic)/scenic-areas/add'
      path: '/scenic-areas/add'
      fullPath: '/scenic-areas/add'
      preLoaderRoute: typeof AuthenticatedscenicScenicAreasAddRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/(scenic)/scenic-spots/$id/edit': {
      id: '/_authenticated/(scenic)/scenic-spots/$id/edit'
      path: '/scenic-spots/$id/edit'
      fullPath: '/scenic-spots/$id/edit'
      preLoaderRoute: typeof AuthenticatedscenicScenicSpotsIdEditRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/(scenic)/scenic-areas/$id/edit': {
      id: '/_authenticated/(scenic)/scenic-areas/$id/edit'
      path: '/scenic-areas/$id/edit'
      fullPath: '/scenic-areas/$id/edit'
      preLoaderRoute: typeof AuthenticatedscenicScenicAreasIdEditRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthenticatedExplanationsRouteRouteChildren {
  AuthenticatedExplanationsRegionTypeIdRoute: typeof AuthenticatedExplanationsRegionTypeIdRoute
}

const AuthenticatedExplanationsRouteRouteChildren: AuthenticatedExplanationsRouteRouteChildren =
  {
    AuthenticatedExplanationsRegionTypeIdRoute:
      AuthenticatedExplanationsRegionTypeIdRoute,
  }

const AuthenticatedExplanationsRouteRouteWithChildren =
  AuthenticatedExplanationsRouteRoute._addFileChildren(
    AuthenticatedExplanationsRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedExplanationsRouteRoute: typeof AuthenticatedExplanationsRouteRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedregionCitiesRoute: typeof AuthenticatedregionCitiesRoute
  AuthenticatedregionContinentsRoute: typeof AuthenticatedregionContinentsRoute
  AuthenticatedregionCountriesRoute: typeof AuthenticatedregionCountriesRoute
  AuthenticatedscenicScenicAreaCategoriesRoute: typeof AuthenticatedscenicScenicAreaCategoriesRoute
  AuthenticatedscenicScenicAreasAddRoute: typeof AuthenticatedscenicScenicAreasAddRoute
  AuthenticatedscenicScenicSpotsAddRoute: typeof AuthenticatedscenicScenicSpotsAddRoute
  AuthenticatedscenicScenicAreasIndexRoute: typeof AuthenticatedscenicScenicAreasIndexRoute
  AuthenticatedscenicScenicSpotsIndexRoute: typeof AuthenticatedscenicScenicSpotsIndexRoute
  AuthenticatedscenicScenicAreasIdEditRoute: typeof AuthenticatedscenicScenicAreasIdEditRoute
  AuthenticatedscenicScenicSpotsIdEditRoute: typeof AuthenticatedscenicScenicSpotsIdEditRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedExplanationsRouteRoute:
    AuthenticatedExplanationsRouteRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedregionCitiesRoute: AuthenticatedregionCitiesRoute,
  AuthenticatedregionContinentsRoute: AuthenticatedregionContinentsRoute,
  AuthenticatedregionCountriesRoute: AuthenticatedregionCountriesRoute,
  AuthenticatedscenicScenicAreaCategoriesRoute:
    AuthenticatedscenicScenicAreaCategoriesRoute,
  AuthenticatedscenicScenicAreasAddRoute:
    AuthenticatedscenicScenicAreasAddRoute,
  AuthenticatedscenicScenicSpotsAddRoute:
    AuthenticatedscenicScenicSpotsAddRoute,
  AuthenticatedscenicScenicAreasIndexRoute:
    AuthenticatedscenicScenicAreasIndexRoute,
  AuthenticatedscenicScenicSpotsIndexRoute:
    AuthenticatedscenicScenicSpotsIndexRoute,
  AuthenticatedscenicScenicAreasIdEditRoute:
    AuthenticatedscenicScenicAreasIdEditRoute,
  AuthenticatedscenicScenicSpotsIdEditRoute:
    AuthenticatedscenicScenicSpotsIdEditRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  errors401LazyRoute: errors401LazyRoute,
  errors403LazyRoute: errors403LazyRoute,
  errors404LazyRoute: errors404LazyRoute,
  errors500LazyRoute: errors500LazyRoute,
  errors503LazyRoute: errors503LazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
